import { authorizedFetch } from '../../helpers/authorizedFetch'
import trans from '../../helpers/trans'
import { generateApiUrl } from '../../helpers/url'
import isResourceCollectionDocument from '../../japi/guards/isResourceCollectionDocument'
import { JapiDocument } from '../../japi/types/Document'
import { FetchCollectionResult, FetchResultType } from '../FetchResult'
import { EmploymentType, EmploymentTypeResource } from './EmploymentType'
import { transformToEmploymentType } from './EmploymentTypeTransformers'

export const getEmploymentTypesApiCall = async (): Promise<FetchCollectionResult<EmploymentType[], string>> => {
    try {
        const url = generateApiUrl({ endpoint: '/employment-types' })

        const response = await authorizedFetch(url)

        const doc: JapiDocument = await response.json()

        if (! isResourceCollectionDocument<EmploymentTypeResource>(doc) || ! doc.data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const employmentTypes = doc.data.map(transformToEmploymentType)

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: employmentTypes,
        }
    } catch (error) {
        console.error('[getEmploymentTypesApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
